import { setWindowLocation } from 'utils/setWindowLocation';

import { getAccessUrl } from './getAccessUrl';

export const redirectToAccess = (region: string, pathname: string = '') => {
  const endpoint = getAccessUrl(region);

  setWindowLocation(`${endpoint}${pathname}`);
};
